import { httpClient } from 'utils/httpClient';
import {
  ReporteNotasSeccion, ReporteAsistenciaEstudiante, ReporteAsistenciaSeccion,
  ReporteMorosidad, ReporteIngresos, ReporteDescuentos,
  ReporteMatriculas, ReporteCargaDocente, ReporteCredencialesEstudiantes,
  ReporteCobros,
} from 'types/reporte.types';

// ============================================================
// reporteService.ts — Llamadas a los 8 endpoints de reportes
// ============================================================

const qs = (params: Record<string, string | number | undefined>) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== '') q.set(k, String(v));
  });
  return q.toString() ? `?${q.toString()}` : '';
};

export const reporteService = {

  notasSeccion(p: { anioEscolarId: number; nivel: string; gradoId: number; seccionId: number }) {
    return httpClient.get<ReporteNotasSeccion>(`/reportes/notas/seccion${qs(p)}`);
  },

  asistenciaEstudiante(estudianteId: number, anioEscolarId: number) {
    return httpClient.get<ReporteAsistenciaEstudiante>(
      `/reportes/asistencia/estudiante/${estudianteId}${qs({ anioEscolarId })}`
    );
  },

  asistenciaSeccion(p: { anioEscolarId: number; nivel: string; gradoId: number; seccionId: number }) {
    return httpClient.get<ReporteAsistenciaSeccion>(`/reportes/asistencia/seccion${qs(p)}`);
  },

  morosidad(anioEscolarId: number) {
    return httpClient.get<ReporteMorosidad>(`/reportes/financiero/morosidad${qs({ anioEscolarId })}`);
  },

  ingresos(anioEscolarId: number, mes?: number) {
    return httpClient.get<ReporteIngresos>(`/reportes/financiero/ingresos${qs({ anioEscolarId, mes })}`);
  },

  descuentos(anioEscolarId: number) {
    return httpClient.get<ReporteDescuentos>(`/reportes/financiero/descuentos${qs({ anioEscolarId })}`);
  },

  resumenMatriculas(anioEscolarId: number) {
    return httpClient.get<ReporteMatriculas>(`/reportes/matriculas/resumen${qs({ anioEscolarId })}`);
  },

  cargaDocente(anioEscolarId: number) {
    return httpClient.get<ReporteCargaDocente>(`/reportes/docentes/carga${qs({ anioEscolarId })}`);
  },

  credencialesEstudiantes(p: { anioEscolarId: number; nivel?: string; gradoId?: number; seccionId?: number }) {
    return httpClient.get<ReporteCredencialesEstudiantes>(`/reportes/usuarios/estudiantes${qs(p)}`);
  },
};

// ── Reportes de cobros adicionales ────────────────────────────

export const reporteCobrosService = {
  porDia(fecha: string) {
    return httpClient.get<ReporteCobros>(`/reportes-cobros/dia?fecha=${fecha}`);
  },
  porMes(mes: number, anio: number) {
    return httpClient.get<ReporteCobros>(`/reportes-cobros/mes?mes=${mes}&anio=${anio}`);
  },
  porAnio(anio: number) {
    return httpClient.get<ReporteCobros>(`/reportes-cobros/anio?anio=${anio}`);
  },
  porIntervalo(desde: string, hasta: string) {
    return httpClient.get<ReporteCobros>(`/reportes-cobros/intervalo?desde=${desde}&hasta=${hasta}`);
  },
};
